export const FormRegistrationEmailTranslationsEn = {
  email: 'Email',
  password: 'Password',
  registration: 'Register',
  privacyPolicyText: 'By clicking Register, you accept',
  privacyPolicyLinkText: 'Privacy Policy',

  // errors
  'Required field': 'Required field',
  'Enter a valid email address': 'Enter a valid email address',
  'Password must be at least 8 characters':
    'Password must be at least 8 characters',
  'Password must be less than 32 characters':
    'Password must be less than 32 characters',
  'Password must contain at least 8 Latin characters, one uppercase letter, one digit':
    'Password must contain at least 8 Latin characters, one uppercase letter, one digit',

  // errors back-end
  'Email in use': 'Email in use.',
};
